import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full pt-16 pb-24 px-6 md:px-12 flex flex-col items-center text-center" data-id="element-39">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="mb-10" data-id="element-40">
        <img src="https://i.postimg.cc/Dy0yjZML/LOGO-(1).png" alt="EBOOK CREATOR Logo" className="w-64 md:w-80 h-auto mx-auto" data-id="element-41" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="max-w-4xl mx-auto space-y-8" data-id="element-42">
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-[#f0f0f0] leading-[1.1]" data-id="element-43">
          Crea tu primer ebook vendible sin bloquearte{' '}
          <br className="hidden md:block" data-id="element-44" />
          <span className="text-3xl md:text-5xl text-gray-400" data-id="element-45">
            (aunque no seas escritor ni diseñador)
          </span>
        </h1>

        <p className="text-lg md:text-xl text-[#00d4aa] font-medium tracking-wide max-w-3xl mx-auto leading-relaxed" data-id="element-46">
          EBOOK CREATOR es un GPT + videos paso a paso que convierte tu idea en
          un ebook con estructura profesional: promesa + título + tabla de
          contenidos + capítulos + cierre con CTA, listo para vender como
          producto de entrada en tu tienda online.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.3,
      duration: 0.8
    }} className="mt-12 mb-16 w-full max-w-md mx-auto shadow-2xl shadow-[#00d4aa]/20 rounded-xl overflow-hidden" data-id="element-47">
        <img src="https://i.postimg.cc/xdCkL5VZ/80b4c3b3.webp" alt="Ebook Creator Cover" className="w-full h-auto object-cover" data-id="element-48" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-2xl mx-auto text-left space-y-8" data-id="element-49">
        <ul className="space-y-4 text-lg text-gray-300" data-id="element-50">
          <li className="flex items-start space-x-3" data-id="element-51">
            <span className="w-2 h-2 mt-2 bg-[#00d4aa] rounded-full flex-shrink-0" data-id="element-52" />
            <span data-id="element-53">
              Sistema guiado: primero el <strong data-id="element-54">orden correcto</strong>,
              después el texto.
            </span>
          </li>
          <li className="flex items-start space-x-3" data-id="element-55">
            <span className="w-2 h-2 mt-2 bg-[#00d4aa] rounded-full flex-shrink-0" data-id="element-56" />
            <span data-id="element-57">
              Prompts en español + checklist <strong data-id="element-58">anti-relleno</strong> para
              evitar contenido genérico.
            </span>
          </li>
          <li className="flex items-start space-x-3" data-id="element-59">
            <span className="w-2 h-2 mt-2 bg-[#00d4aa] rounded-full flex-shrink-0" data-id="element-60" />
            <span data-id="element-61">
              Diseñado para principiantes: avanza en 1–2 sesiones de trabajo.
            </span>
          </li>
        </ul>

        <div className="pt-8 flex flex-col items-center text-center space-y-4" data-id="element-62">
          <a href="https://aprendeemprendearg.com/cart/52712282784111:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'InitiateCheckout', {
              content_name: 'EBOOK CREATOR',
              content_category: 'GPT',
              value: 18990,
              currency: 'ARS'
            });
          }
        }} className="w-full md:w-auto bg-[#00d4aa] hover:bg-[#00bfa0] text-black font-bold text-lg px-8 py-4 rounded-lg transition-all transform hover:scale-105 inline-block no-underline" data-id="element-63">
            Quiero crear mi ebook →
          </a>
          <p className="text-sm text-gray-500" data-id="element-64">
            Acceso inmediato · Incluye videos · Funciona para cualquier nicho
          </p>
        </div>
      </motion.div>
    </section>;
}